export default __webpack_public_path__ + "static/media/img_gas_phase_en_01.46c20061.png";